import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-tai-chi-walking-v2-al',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-f', 'age-tai-chi-walking-f'],
		route: {
			path: '/tai-chi-walking-f-v2-al',
			name: 'tai-chi-walking-f-v2-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-walking-v2-al',
		route: {
			path: '/tai-chi-walking-f-v2-al/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-tai-chi-walking-v2-al',
		},
		slug: 'activity-female-tai-chi-walking-v2-al',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-walking-f-v2-al',
	},
	upsell: {
		routeNames: ['upsell-tai-chi-walking-f'],
	},
}

export default appAreaConfig
